<template>
  <div class="articles">
    <h1
      v-if="category.title.toLowerCase() === $t('accountTitle').toLowerCase() "
      class="title"
    >{{$t('altAccountTitle')}}</h1>
    <h1 v-else class="title">{{category.title}}</h1>
    <div>
      <ul class="list pa0 ma0">
        <li v-for="(article) in articles" :key="article.name">
          <button
            class="article-button"
            v-on:click="handleArticleClick(article.id)"
            :class="{
              'article-button--active': openArticleIds.includes(article.id)
            }"
          >
            <a
              style="color: inherit; text-decoration: inherit;"
              v-bind:href="`#${article.source_id}-${article.title.replace(/ /g, '-')}`"
            >{{ article.title }}</a>
          </button>
          <div class="article-body" v-show="openArticleIds.includes(article.id)">
            <div v-html="article.body"></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name
  },
  data() {
    return {
      openArticleIds: []
    };
  },
  methods: {
    handleArticleClick(id) {
      if (this.openArticleIds.includes(id)) {
        let index = this.openArticleIds
          .map(x => {
            return x.Id;
          })
          .indexOf(id);

        this.openArticleIds.splice(index, 1);
      } else {
        this.openArticleIds.push(id);
      }
    }
  },
  computed: {
    pageTitle() {
      const pageTitle = this.name;
      return pageTitle;
    },
    category() {
      const name = this.$store.state.categories[this.$route.meta.categoryId];
      return name;
    },
    articles() {
      const articlesArray = this.$store.state.articles[this.$route.meta.categoryId];
      return articlesArray;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.articles {
  .title {
    margin-bottom: 0.5rem;
    text-transform: capitalize;
  }
}

.article-button {
  color: $theme-highlight;
  -webkit-appearance: none;
  background: transparent;
  border: 0;
  text-align: left;
  font-weight: 600;
  cursor: pointer;
  transition: 0.1s linear color;
  padding: 0.2rem 0;
  margin: 0 0 1.25rem 0;
  width: 100%;

  &:hover {
    color: #b4b4b4;
  }
  &--active {
    margin: 0;
  }
}
.article-body {
  margin-bottom: 2rem;
  margin-bottom: 40px;
  font-size: 0.9em;
  font-family: Roboto, Helvetica, Arial, sans-serif;

  a {
    color: $theme-highlight;
    text-decoration: none;
  }
}
</style>
